import {
  Cpu, BadgeCheck, Users, Target, Cog, SearchCheck,
  TrendingDown, Truck, Handshake, Infinity as InfinityIcon,
} from "lucide-react";
import { Reveal } from "../motion";
import { Eyebrow } from "../CTA";
import { WHY_CHOOSE } from "../../lib/site";

const icons = {
  Cpu, BadgeCheck, Users, Target, Cog, SearchCheck,
  TrendingDown, Truck, Handshake, Infinity: InfinityIcon,
};

const WhyChooseUs = () => {
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="why-choose-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-3xl">
          <Eyebrow>Why Choose Us</Eyebrow>
          <h2 className="mt-5 font-display text-4xl font-medium tracking-tight text-navy sm:text-5xl">
            Engineered for reliability.
            <br />
            <span className="text-steel">Trusted for performance.</span>
          </h2>
        </div>

        <div className="mt-14 grid gap-px overflow-hidden rounded-3xl border border-navy/10 bg-navy/10 sm:grid-cols-2 lg:grid-cols-5">
          {WHY_CHOOSE.map((item, i) => {
            const Icon = icons[item.icon] || Cog;
            return (
              <Reveal key={item.title} delay={(i % 5) * 0.05}>
                <div
                  className="group h-full bg-white p-7 transition-colors duration-300 hover:bg-surface"
                  data-testid={`why-choose-${i}`}
                >
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-navy text-white transition-colors duration-300 group-hover:bg-brand">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-semibold text-navy">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-slate-500">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
